import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";

const systemPhrases = [
  "focused skill development",
  "measurable mastery",
  "precision learning",
  "targeted feedback"
];

const calculusPhrases = [
  "Weierstrass substitutions",
  "ε‑δ proofs of continuity",
  "Taylor series expansions",
  "improper integral convergence",
  "partial fraction decomposition"
];

const financePhrases = [
  "risk-weighted asset calculations",
  "Tier 1 capital classifications",
  "credit conversion factors",
  "Basel I capital buffers",
  "off-balance sheet exposure"
];

export default function About() {
  const [sysIndex, setSysIndex] = useState(0);
  const [calcIndex, setCalcIndex] = useState(0);
  const [finIndex, setFinIndex] = useState(0);

  useEffect(() => {
    const sysTimer = setInterval(() => {
      setSysIndex(i => (i + 1) % systemPhrases.length);
    }, 4000);
    const calcTimer = setInterval(() => {
      setCalcIndex(i => (i + 1) % calculusPhrases.length);
    }, 2700);
    const finTimer = setInterval(() => {
      setFinIndex(i => (i + 1) % financePhrases.length);
    }, 2900);
    return () => {
      clearInterval(sysTimer);
      clearInterval(calcTimer);
      clearInterval(finTimer);
    };
  }, []);

  return (
    <main className="px-6 py-10 max-w-4xl mx-auto text-center text-gray-800">
      <section className="text-lg md:text-xl leading-relaxed text-gray-700 space-y-6 text-left">
        <p>
          Mindzera is a cognitive operating system for{" "}
          <AnimatePresence mode="wait">
            <motion.span
              key={systemPhrases[sysIndex]}
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -8 }}
              transition={{ duration: 0.5 }}
              className="inline-block text-green-700 font-semibold"
            >
              {systemPhrases[sysIndex]}
            </motion.span>
          </AnimatePresence>
          .
        </p>

        <p>
          We break knowledge domains into microskills for targeted practice and feedback, revealing what you’ve mastered and what you haven’t at the all-important level of details.
        </p>

        <p>
          Students might attend calculus lectures but struggle with{" "}
          <AnimatePresence mode="wait">
            <motion.span
              key={calculusPhrases[calcIndex]}
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -8 }}
              transition={{ duration: 0.5 }}
              className="inline-block text-blue-700 font-semibold"
            >
              {calculusPhrases[calcIndex]}
            </motion.span>
          </AnimatePresence>
          . Managers might complete Basel II training but fail at{" "}
          <AnimatePresence mode="wait">
            <motion.span
              key={financePhrases[finIndex]}
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -8 }}
              transition={{ duration: 0.5 }}
              className="inline-block text-blue-700 font-semibold"
            >
              {financePhrases[finIndex]}
            </motion.span>
          </AnimatePresence>
          .
        </p>

        <p>
          That's why we build knowledge from the ground up—through AI‑generated or manually added microskills you can train, track, analyze, or even assign to others.
        </p>
      </section>

      {/* Call-to-action button */}
      <div className="mt-12 text-center">
        <button className="bg-green-700 text-white font-semibold py-3 px-6 rounded-2xl shadow-md hover:bg-green-800 transition">
          Build Your Mindzera Map
        </button>
      </div>
    </main>
  );
}
